import { RestrictedAreasModel } from '../models/restricted-areas-model';
import { ZoneFeature } from '../models/zones-base-interfaces';
import { ZoneLayerBase } from './zone-layer-base';

export class RestrictedAreasLayer extends ZoneLayerBase {
    async getZones(): Promise<ZoneFeature[]> {
        const zones = await RestrictedAreasModel!.getRestrictedAreas();
        return zones || [];
    }
    
    getText(feature: ZoneFeature): string {
        return `${feature.properties.description}`;
    }
    
    zoneId: string = "RestrictedAreasLayer";
}
